<template>
  <div class="d-flex w-100 mt-3" v-for="item in info" :key="item.title">
    <span class="material-symbols-outlined"> {{ item.icon }} </span>
    <div class="ms-3">
      <p class="fw-bold text-black my-0">{{ item.title }}</p>
      <p class="my-0">{{ item.description }}</p>
    </div>
  </div>

  <div class="floating-btn">
    <Button
      id="btn-continue"
      class="text-start w-100 p-3"
      @click="clickBtn"
      :disabled="disableBtn"
    >
      <p class="text-white text-center fw-bold my-auto">
        {{ t("CL_WITHDRAWAL.ACCEPT_CONTINUE_BTN") }}
      </p>
    </Button>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import Button from "@/apps/credit-line/components/Button.vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";

export default defineComponent({
  name: "WithdrawalDetails",
  components: { Button },
  emits: ["next", "setScreenTitle"],
  props: {
    amount: String,
    totalInterestRate: String,
    availabilityFee: Number,
    insuranceFee: Number,
    paymentPlan: String,
    nextPayment: String,
    forwardAccount: String,
    disableBtn: Boolean,
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const info = [
      {
        title: props.amount,
        description: t("CL_WITHDRAWAL.AMOUNT"),
        icon: "attach_money",
      },
      {
        title: props.totalInterestRate,
        description: t("CL_WITHDRAWAL.TOTAL_INTEREST_RATE"),
        icon: "arrow_downward",
      },
      {
        title: props.paymentPlan,
        description: t("CL_WITHDRAWAL.PAYMENT_PLAN"),
        icon: "table",
      },
      {
        title: props.nextPayment,
        description: t("CL_WITHDRAWAL.NEXT_PAYMENT"),
        icon: "calendar_month",
      },
    ];

    if (props.forwardAccount) {
      info.push({
        title: props.forwardAccount,
        description: t("CL_WITHDRAWAL.FORWARD_ACCOUNT"),
        icon: "wallet",
      });
    }
    if (props.availabilityFee && props.insuranceFee) {
      info.push(
        {
          title: `${props.availabilityFee}%`,
          description: t("CL_WITHDRAWAL.AVAILABILITY_FEE"),
          icon: "verified_user",
        },
        {
          title: `${props.insuranceFee}%`,
          description: t("CL_WITHDRAWAL.INSURANCE_FEE"),
          icon: "percent",
        }
      );
    }

    const clickBtn = () => {
      emit("next");
    };

    onMounted(() =>
      emit("setScreenTitle", t("CL_WITHDRAWAL.WITHDRAW_DETAILS"))
    );
    return { t, info, clickBtn, useAsset };
  },
});
</script>

<style lang="scss" scoped>
.bottom {
  margin-top: 100%;
}
.disabled {
  filter: grayscale(60%) saturate(50%);
  pointer-events: none;
}
.btn-text {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.floating-btn {
  background-color: white;
  position: fixed;
  padding: 10px 20px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200;
}

.material-symbols-outlined {
  font-variation-settings: "FILL" 0, "wght" 200, "GRAD" 0, "opsz" 24;
}
</style>
